/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { CityWorksRequestViewResponse } from 'src/app/state-management';

@Injectable()
export class CityworksService {
	private handleError: HandleError;
	httpOptions = {
		headers: new HttpHeaders({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	};

	cityworksUrl = 'api/cityworks';

	constructor(private httpClient: HttpClient, httpErrorHandler: HttpErrorHandler) {
		this.handleError = httpErrorHandler.createHandleError('AdminService');
	}

	getCityworksTransferMapping(): Observable<any> {
		return this.httpClient.get(`${this.cityworksUrl}/ProblemMapping`, this.httpOptions);
	}

	transferToCityworks(transferPayload: any): Observable<any> {
		return this.httpClient.post(
			`${this.cityworksUrl}/CreateRequest/${transferPayload.caseNo}/${transferPayload.originalCaseNo || transferPayload.caseNo}`,
			this.httpOptions,
		);
	}

	getCityworksView(requestNo: number): Observable<CityWorksRequestViewResponse> {
		return this.httpClient.get<CityWorksRequestViewResponse>(`${this.cityworksUrl}/RequestView/${requestNo}`, this.httpOptions);
	}
}
